import { ArrowRight, Filter, Plus, Search } from "react-feather";
import styles from "./keyfobfilter.module.css";
import { useEffect, useState } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";

const KeyfobFilter = ({ filterData, setFilterData, setShowAddFormKeyFob, setPage }) => {
    const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();
    const [filterOpen, setFilterOpen] = useState(false);
    const [propertyList, setPropertyList] = useState([]);

    useEffect(() => {
        const fetchAllProperties = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios(process.env.REACT_APP_DEVICE_API_URL + "v1/properties", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                let propertyData = response.data.data;

                propertyData = [{ value: "all", label: "All", apartments: [] }].concat(propertyData);
                setPropertyList(propertyData);
            });
        };
        fetchAllProperties();
    }, [getAccessTokenSilently]);

    return <div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" onChange={(e) => {
                    setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; });
                    setPage(0);
                }} />
            </div>
        </div>
        <div className={`${styles.FilterSec}`}>
            <div className={!filterOpen ? `${styles.FilterFieldSec}` : `${styles.FilterFieldSec} ${styles.Open}`}>
                <p className={`${styles.FilterTitle}`}>
                    Filters
                    <span onClick={(e) => setFilterOpen(false)}><ArrowRight /></span>
                </p>
                <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Property</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Property"
                            value={filterData?.property}
                            onChange={(e) => {
                                setFilterData((prev) => {
                                    return { ...prev, property: e.target.value };
                                });
                            }}
                        >
                            {propertyList?.map((i) => {
                                return (<MenuItem key={i.value} value={i.value}>{i.label}</MenuItem>);
                            })}
                        </Select>
                    </FormControl>
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Type</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Type"
                            value={filterData?.product}
                            onChange={(e) => {
                                setFilterData((prev) => {
                                    return { ...prev, type: e.target.value };
                                });
                            }}
                        >
                            <MenuItem value="all">All</MenuItem>
                            <MenuItem value="Tenant">Tenant</MenuItem>
                            <MenuItem value="User">User</MenuItem>
                            <MenuItem value="Other">Other</MenuItem>
                        </Select>
                    </FormControl>
                </div>
            </div>
            <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
                <Filter />
            </Link>
            {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("device-keyfob:create") > -1) && <Link className={`${styles.AddNoteBu}`} onClick={(e) => setShowAddFormKeyFob(true)}>
                <Plus /> <span>KeyFob</span>
            </Link>}
        </div>
    </div>
}

export default KeyfobFilter;